import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from "react";
export function useCompactMenuFocus(open) {
  const $ = _c(5);
  const menuItemsRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const container = menuItemsRef.current;
      if (!container) {
        return;
      }
      const selectors = ["[data-compact-menu-item=\"true\"][data-active=\"true\"]:not([data-disabled=\"true\"])", "[data-compact-menu-item=\"true\"]:not([data-disabled=\"true\"])"];
      for (const selector of selectors) {
        const target = container.querySelector(selector);
        if (!target) {
          continue;
        }
        requestAnimationFrame(() => {
          if (!target.isConnected) {
            return;
          }
          target.focus();
        });
        break;
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const focusInitialMenuItem = t0;
  const wasOpenRef = useRef(open);
  let t1;
  let t2;
  if ($[1] !== open) {
    t1 = () => {
      if (open && !wasOpenRef.current) {
        focusInitialMenuItem();
      }
      wasOpenRef.current = open;
    };
    t2 = [open, focusInitialMenuItem];
    $[1] = open;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      menuItemsRef,
      focusInitialMenuItem
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}